import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanDetailSchema } from './shapes';

export const createReleasePlan = defineEndpoint({
  method: 'POST',
  path: '/v1/release-plans',
  params: z.object({}),
  query: z.object({}),
  body: z.object({
    name: z.string().trim().min(1).max(200),
    productIds: z.array(z.string().uuid()).min(1).max(20),
  }),
  response: z.object({ data: PlanDetailSchema }),
  successStatus: 201,
});
